import { BasicScrollView } from "@/components/BasicScrollView";
import Head from 'expo-router/head';
import Footer from '@/components/Footer';
import * as TextBlocks from '@/utilities/TextBlocks';
import { MarkdownBlock } from '@/utilities/TextBlocks';
import { Meta } from "@/components/Meta";

export default function Refunds() {
  return (
    <BasicScrollView center={false}>
      <Meta title={"Refunds"} />
      <MarkdownBlock markdown={TextBlocks.REFUNDS_MARKDOWN} />
      <Footer />
    </BasicScrollView>
  );
}
